import { useEffect, useState } from "react";

export const useDebounceValue = <T,>(value: T, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    const subscription = setTimeout(() => setDebouncedValue(value), delay);

    return () => {
      clearTimeout(subscription);
    };
  }, [value, delay]);

  return debouncedValue;
};
